import { render, staticRenderFns } from "./CreditsModalPayConfirmation.vue?vue&type=template&id=4954d692&scoped=true&"
import script from "./CreditsModalPayConfirmation.vue?vue&type=script&lang=js&"
export * from "./CreditsModalPayConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./CreditsModalPayConfirmation.vue?vue&type=style&index=0&id=4954d692&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4954d692",
  null
  
)

export default component.exports